import React from 'react';
import { Svg, ISvg } from '../../Svg';

export const ChatGPT: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 46 46" fill="none" {...props}>
    <path
      d="M17 1.91675L20.9772 9.21836L28.25 13.2114L20.9772 17.2044L17 24.506L13.0228 17.2044L5.75 13.2114L13.0228 9.21836L17 1.91675ZM32.75 20.7412L35.402 25.6084L40.25 28.2709L35.402 30.9334L32.75 35.8007L30.098 30.9334L25.25 28.2709L30.098 25.6084L32.75 20.7412ZM17 36.5536L18.326 38.9873L20.75 40.3185L18.326 41.6498L17 44.0834L15.674 41.6498L13.25 40.3185L15.674 38.9873L17 36.5536Z"
      fill="white"
    />
  </Svg>
);
